export var Video;

(function (Video) {
  Video["QQ"] = "qq";
  Video["VIDYARD"] = "vidyard";
  Video["VIMEO"] = "vimeo";
  Video["YOUTUBE"] = "youtube";
  Video["KALTURA"] = "kaltura";
})(Video || (Video = {}));